"use client";
import {
  motion,
  useScroll,
  useMotionValueEvent,
} from "motion/react"; // Note: Ensure your package matches "motion/react" or "framer-motion"
import { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Button, IconButton, Typography, useTheme } from "@mui/material";
import { ColorModeContext, tokens } from "../../theme";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import { Link } from "react-scroll";
import Resume from "../../assets/William Jiang Software Engineer 2026.pdf";

// 1. Create a motion-enabled Material UI Box component
const MotionBox = motion(Box);

const Header = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const colorMode = useContext(ColorModeContext);
  const { scrollY } = useScroll();
  const [hidden, setHidden] = useState(false);

  useMotionValueEvent(scrollY, "change", (current) => {
    const previous = scrollY.getPrevious() ?? 0;
    if (current > previous && current > 150) {
      setHidden(true);
    } else {
      setHidden(false);
    }
  });

  return (
    // 2. Use MotionBox and inject your Tailwind classes into MUI's sx prop or layout logic
    <MotionBox
      // Framer Motion Animation Properties
      animate={{
        y: hidden ? -120 : 0,
        opacity: hidden ? 0 : 1,
      }}
      transition={{ duration: 0.25, ease: "easeOut" }}
      
      // Combined MUI sx styles + your tailwind configuration layout
      sx={{
        position: "fixed",
        top: "30px",          // equivalent to top-10
        left: "10%",          // combined with width 80% and mx: "auto" mimics inset-x-0 mx-auto
        width: "80%",
        zIndex: 50,           // z-50
        borderRadius: "8px",  // rounded-lg
        border: `1px solid ${theme.palette.divider}`, // border
        backdropFilter: "blur(8px)", // backdrop-blur
        mb: "30px",
        display: "flex",
        justifyContent: "space-between", // Fixed: your inner box split had a closure bug, changed to space-between
        alignItems: "center",
        py: 2,
        px: 3,
        backgroundColor: theme.palette.mode === "dark" ? "rgba(18, 18, 18, 0.8)" : "rgba(255, 255, 255, 0.8)", // bg-white/80 style
      }}
    >
      {/* Left side: Logo */}
      <Box>
        <Typography
          variant="Topbar"
          onClick={() => navigate("/")}
          sx={{ cursor: "pointer", fontWeight: "bold" }}
        >
          WJ
        </Typography>
      </Box>

      {/* Right side: Navigation Items */}
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Link to="project" smooth={true} duration={200} offset={-70}>
          <Button sx={{ margin: "0 10px", fontFamily: "PT serif, sans-serif" }}>
            <Typography>Projects</Typography>
            
          </Button>
        </Link>
        <Link
          onClick={() => navigate("/notes")}
          smooth={true}
          duration={200}
          offset={-70}
        >
          <Button sx={{ margin: "0 10px", fontFamily: "PT serif, sans-serif" }}>
          <Typography>Posts</Typography>
          </Button>
        </Link>
        <Button
          sx={{ margin: "0 10px", fontFamily: "PT serif, sans-serif" }}
          onClick={() => window.open(Resume, "_blank")}
        >
            <Typography>Resume</Typography>
        </Button>

        <iframe
          src={Resume}
          width="100%"
          height="100%"
          style={{ border: "none", display: "none" }}
          title="Resume"
        />

        <IconButton
          onClick={colorMode.toggleColorMode}
          sx={
            theme.palette.mode === "dark"
              ? { color: colors.blueAccent[300] }
              : { color: "#ffda03" }
          }
        >
          {theme.palette.mode === "dark" ? (
            <DarkModeOutlinedIcon />
          ) : (
            <LightModeOutlinedIcon />
          )}
        </IconButton>
      </Box>
    </MotionBox>
  );
};

export default Header;
